<template>
  <div class="bg-white px-4" v-loading="loading">
    <div class="row py-2">
      <div :class="modifiable ? 'col-12' : 'col-8 offset-2'">
        <div class="d-flex justify-content-between">
          <p class="fs-20 fw-500" v-if="!modifiable">{{ form.name }}</p>
          <div
            class="cursor-pointer"
            v-if="prop_indication_order && !editing"
            @click="editing = true"
          >
            <i class="el-icon-edit fs-24"></i>
          </div>
        </div>
      </div>
      <div class="col-6" v-show="modifiable">
        <div class="box-shadow p-2">
          <div
            class="fs-18 fw-500 txt-grey-900 mb-3 max-line-1"
          >{{ $t("schedule_page.lbl_add_indicator") }}</div>
          <div class="flex flex-col md:flex-row gap-3 items-center">
            <el-input
              ref="serviceSearchInput"
              :placeholder="$t('schedule_page.lbl_search_sh')"
              suffix-icon="el-icon-search"
              v-model="search"
              :clearable="true"
              @input="handleSearchService"
              @keydown.down.native.prevent="moveActiveService(1)"
              @keydown.up.native.prevent="moveActiveService(-1)"
              @keydown.enter.native.prevent="toggleActiveService"
            ></el-input>
            <el-button
              v-if="hasExaminationEcom"
              @click="handleOpenModalSelectServicePublic"
              type="primary"
              size="medium"
            >{{ $t("Dịch vụ TMĐT") }}</el-button>
          </div>
          <div class="flex flex-wrap gap-2 my-2">
            <button v-for="tab in indicationTypeTabs" :key="String(tab.value)" type="button" class="px-3 py-2 rounded-lg border" :class="selectedIndicationType === tab.value ? 'bg-indigo-200 border-indigo-500' : 'bg-white'" @click="selectIndicationType(tab.value)">{{ tab.label }}</button>
          </div>
          <div
            v-if="handledIndicationCategories.length"
            ref="quickServiceList"
            class="quick-service-list mt-2"
            tabindex="0"
            v-infinite-scroll="handleNexPageCategories"
            :infinite-scroll-disabled="disabledScroll"
            @keydown.down.prevent="moveActiveService(1)"
            @keydown.up.prevent="moveActiveService(-1)"
            @keydown.enter.prevent="toggleActiveService"
            @keydown.space.prevent="toggleActiveService"
          >
            <div
              v-for="(item, index) in handledIndicationCategories"
              :key="`quick-service-${item.id}`"
              class="quick-service-item"
              :class="{
                'quick-service-item-active': activeServiceIndex === index,
                'quick-service-item-selected': isServiceSelected(item)
              }"
              role="button"
              @mouseenter="activeServiceIndex = index"
              @click="toggleServiceSelection(item)"
            >
              <div class="flex-1 min-w-0">
                <div class="fs-15 fw-500 max-line-1">{{ getIndicationName(item) }}</div>
                <div v-if="item.service_catalog && item.service_catalog.services_code" class="fs-12 txt-grey-600">
                  {{ item.service_catalog.services_code }}
                </div>
              </div>
              <i
                class="fs-18"
                :class="isServiceSelected(item) ? 'el-icon-check txt-pri' : 'el-icon-plus txt-grey-600'"
              ></i>
            </div>
          </div>
          <p
            class="text-center mt-2"
            v-if="indication_categories_loading"
          >{{ $t("schedule_page.lbl_loading") }}</p>
<!--          <div v-if="!selectedIndicationType" class="flex space-x-3 my-3 select-class pb-1">-->
<!--            <div-->
<!--              class="cursor-pointer px-3 py-2 hover:bg-indigo-300 text-black rounded-lg class-item"-->
<!--              :class="!indicationClassParentId ? 'bg-indigo-200' : ''"-->
<!--              :key="0 + 'level1'"-->
<!--              @click="selectIndicationClasses(0)"-->
<!--            >{{ $t("schedule_page.lbl_all") }}</div>-->
<!--            <div-->
<!--              class="cursor-pointer px-3 py-2 hover:bg-indigo-300 text-black rounded-lg class-item"-->
<!--              :class="-->
<!--                indicationClassParentId === item.id-->
<!--                  ? 'bg-indigo-200'-->
<!--                  : 'bg-light'-->
<!--              "-->
<!--              v-for="item in indicationClasses"-->
<!--              :key="item.id + 'indicationClasses'"-->
<!--              @click="selectIndicationClasses(item.id)"-->
<!--            >{{ item.name }}</div>-->
<!--          </div>-->
          <div v-if="showLegacyServiceTree" class="h-tree select-items pt-2">
            <div
              v-infinite-scroll="handleNexPageCategories"
              :infinite-scroll-disabled="disabledScroll"
            >
              <el-tree
                v-loading="indication_class_loading"
                class="filter-tree"
                :data="handledIndicationCategories"
                check-on-click-node
                @check-change="handleCheckChange"
                show-checkbox
                ref="tree"
                node-key="id"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span class="fs-16 txt-grey-900 mb-0">
                    {{
                    getIndicationName(data) || node.disabled
                    }}
                  </span>
                  <!-- <br />
                  <span class="fs-13 txt-pri" v-html="getCategoryLabel(data.label)"></span>-->
                </span>
              </el-tree>
              <p
                class="text-center"
                v-if="indication_categories_loading"
              >{{ $t("schedule_page.lbl_loading") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div :class="modifiable ? 'col-6 relative' : 'col-8 offset-2 relative'">
        <div class="mb-2">
          <div class="mb-1"><strong>Mẫu phiếu chỉ định</strong></div>
          <el-input
            v-model="indTempSearch"
            class="mb-2"
            suffix-icon="el-icon-search"
            clearable
            placeholder="Tìm mẫu chỉ định"
            @input="handleSearchIndTemp"
          ></el-input>
          <div class="ind-temp-list" :class="{ 'ind-temp-list-empty': !indTemps.length }">
            <div
              v-for="item in indTemps"
              :key="item.id"
              class="ind-temp-item"
              :class="{ 'ind-temp-item-active': selectedIndTemp && selectedIndTemp.id === item.id }"
              role="button"
              @click="selectIndicationTemplate(item)"
            >
              <div class="flex-1 min-w-0">
                <div class="fw-500 max-line-1">{{ item.name }}</div>
                <div class="fs-12 txt-grey-600">
                  {{ getTemplateServiceCount(item) }} dịch vụ
                </div>
              </div>
              <el-button
                @click.prevent.stop="deleteTemplate(item)"
                type="text"
                size="small"
                icon="el-icon-delete"
              ></el-button>
            </div>
            <div v-if="!indTemps.length" class="txt-grey-600 fs-14 p-2 text-center">
              Không có mẫu chỉ định
            </div>
          </div>
        </div>
        <div>
          <div class="mb-1"><strong>Tên phiếu chỉ định</strong></div>
          <el-input
            placeholder="Tên phiếu chỉ định"
            v-model="form.name"
            :clearable="true"
            v-if="modifiable"
          ></el-input>
        </div>
        <!-- <div
          class="fs-18 fw-500 txt-grey-900 mb-3 flex items-center justify-between mt-2"
        >
          <span>{{ $t("schedule_page.lbl_indication_list") }}</span>
          <div
            v-if="indicationServices && indicationServices.length"
            class="flex gap-2"
          >
            <div
              class="ml-auto px-3 py-2 rounded-lg border border-primary flex cursor-pointer btn-add"
              @click="handleOpenModalAddReceipt(show)"
            >
              <img
                src="@public/assets/images/icon/patientVisit/plus-circle.svg"
                alt
              />
              <p class="text-primary mb-0 ml-2 text-center text-sm">
                Tạo phiếu thu
              </p>
            </div>
            <div
              @click="handleOpenListReceipt"
              class="ml-auto px-3 py-2 rounded-lg border border-primary flex cursor-pointer btn-add"
            >
              <p class="text-primary mb-0 text-center text-sm">DS phiếu thu</p>
            </div>
          </div>
        </div>-->
        <div ref="selectedIndicationList" :class="`selected-indication mt-2 ${indTemps.length ? 'ind-temp-selected' : ''}`">
          <div
            class="selected-indication-item"
            :class="modifiable ? 'indication-item-hover' : ''"
            v-for="(indication, index) in selected"
            :key="'idct' + index"
          >
            <div v-if="indication" class="flex align-items-center justify-content-between">
              <div class="w-100 p-1 flex justify-between items-center gap-1">
                <p class="fs-16 fw-500 txt-grey-900 mb-0 flex-1">{{ getIndicationName(indication) }}</p>
                <el-input-number class="cs-input" v-model="indication.indicationAmount" :min="1"></el-input-number>
                <!-- <div class="row" :class="!modifiable ? 'disable-click' : ''">
                  <div class="col-6">
                    <div class="dropdown">
                      <div
                        class="cursor-pointer el-icon-map-location d-flex h-40px align-items-center"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span class="max-line-1 ml-1 fs-14 txt-grey-600">
                          {{
                            indication.target_name
                              ? indication.target_name
                              : modifiable
                              ? $t("schedule_page.lbl_execution")
                              : $t("schedule_page.lbl_no_exe_place")
                          }}
                        </span>
                      </div>
                      <div
                        class="dropdown-menu h-30 overflow-y-auto"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a
                          class="dropdown-item"
                          href="javascript:;"
                          v-for="target in demo"
                          :key="target.id + 'target-item'"
                          @click="setNameTargetIndication(indication, target)"
                          >{{ target.name }}</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="cursor-pointer fs-14 txt-grey-600">
                      <el-date-picker
                        prefix-icon="el-icon-date"
                        v-model="indication.due_date"
                        type="date"
                        :placeholder="
                          modifiable
                            ? $t('schedule_page.lbl_due_date')
                            : $t('schedule_page.lbl_no_due_date')
                        "
                        class="input-deal-date"
                        :clearable="false"
                      ></el-date-picker>
                    </div>
                  </div>
                </div>-->
              </div>
              <div class="delete-indication-wraper text-right">
                <span
                  role="button"
                  @click="handleDeleteIndication(indication)"
                  class="delete-indication"
                >
                  <i class="el-icon-close fs-22"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="d-flex justify-content-end mt-2" v-if="modifiable">
          <button
            class="btn btn-light mr-2"
            @click="handlerCancel"
          >{{ $t("schedule_page.btn_cancel") }}</button>
          <button class="btn btn-light mr-2" @click="handleShowDialogSaveIndTemp">{{ $t("Lưu mẫu chỉ định") }}</button>
          <button :disabled="isDisabledCreate" class="btn bg-pri text-white" @click="onSubmit()">
            {{
            $t(
            prop_indication_order && prop_indication_order.id
            ? "Cập nhật"
            : "Tạo phiếu"
            )
            }}
          </button>
        </div>
        <div v-else-if="prop_indication_order" class="d-flex justify-content-end mt-2">
          <button
            class="btn bg-pri text-white"
            @click="goToPrint"
          >{{ $t("schedule_page.btn_print") }}</button>
        </div>
      </div>
    </div>
    <!-- <ModalAddReceiptForm
      v-if="indicationServices && indicationServices.length"
      :indicationResponse="indicationResponse"
      @cancel="handleOpenModalAddReceipt('')"
      @onRefresh="handleRefresh"
    ></ModalAddReceiptForm>
    <ModalIndicationReceipt
      ref="ModalIndicationReceipt"
      :ctaTrigger="ctaTrigger"
      :indicationResponse="indicationResponse"
      @onClose="handleCloseModalIndicationReceipt"
    />-->
    <ModalSelectServicePublic
      :selectedServiceProp="selectedEcomService"
      ref="ModalSelectServicePublic"
      @onSelected="handleSelectServiceEcom"
    />
    <ModalConfirmConcent ref="ModalConfirmConcent" @onSuccess="handleOpenModalEnterOTP" />
    <ModalEnterOTP ref="ModalEnterOTP" @onSuccess="onSubmit" />
    <el-dialog
      :title="$t('Tên mẫu phiếu chỉ định')"
      :visible.sync="showDialogSaveIndTemp"
      width="30%"
      append-to-body
      center
      :before-close="handleCancelSaveIndTemp"
    >
      <div>
        <el-input v-model="indTempName" :placeholder="$t('Nhập tên mẫu phiếu chỉ định')"></el-input>
        <div class="d-flex justify-content-end mt-4">
          <button class="btn btn-light mr-2" @click="handleCancelSaveIndTemp">{{ $t("schedule_page.btn_cancel") }}</button>
          <button :disabled="!indTempName" class="btn bg-pri text-white" @click="handleSaveIndTemp()">
            {{ $t("Lưu mẫu") }}
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import dataDemo from '../../../pages/ElectronicMedicalRecords/components/Indications/ModalIndication/dataMemo'
import { EXAMINATION_STATUS } from '../../../utils/constants'
import ModalIndicationReceipt from './ModalIndicationReceipt.vue'
import ModalAddReceiptForm from './modal/ModalAddReceiptForm.vue'
import ModalSelectServicePublic from './modal/ModalSelectServicePublic.vue'
import { cloneDeep } from 'lodash'
import ModalConfirmConcent from './modal/ModalConfirmConcent.vue'
import ModalEnterOTP from './modal/ModalEnterOTP.vue'
import { mixinHasFeatures } from '@/utils/mixinHasFeatures'

export default {
  name: 'CUInficationOrderV2',
  mixins: [mixinHasFeatures],

  components: {
    ModalIndicationReceipt,
    ModalAddReceiptForm,
    ModalSelectServicePublic,
    ModalConfirmConcent,
    ModalEnterOTP
  },
  props: {
    patientVisit: {
      type: Object
    },
    patient_visit_id: {
      type: Number,
      required: true
    },
    mr_id: {
      type: Number
    },
    hr_id: {
      type: Number
    },
    type: {
      type: Number
    },
    prop_indication_order: {
      type: Object
    }
  },
  data () {
    return {
      modify: false,
      form: {
        name: ''
      },
      selected: [],
      deleted: [],
      search: '',
      indicationClasses: [],
      indicationClassParentId: null,
      selectedIndicationType: null,
      allIndicationTypes: [1, 2, 4, 3],
      indicationPagingByType: {},
      indicationTypeTabs: [
        { value: null, label: 'Tất cả' },
        { value: 1, label: 'Xét nghiệm' },
        { value: 2, label: 'Chẩn đoán hình ảnh' },
        { value: 4, label: 'Sinh học phân tử' },
        { value: 3, label: 'Chỉ định khác' }
      ],
      indication_class_loading: false,
      indication_categories_loading: false,
      demo: dataDemo,
      moment,
      editing: false,
      loading: false,
      indication_order: null,
      indicationCategoriesPaging: {},
      count: 0,
      show: 'test',
      indicationResponse: {},
      indicationServices: [],
      ctaTrigger: 0,
      isDisabledCreate: false,
      stepConfirm: 0,
      selectedEcomService: [],
      selectedIndTemp: null,
      indTemps: [],
      indTempSearch: '',
      indTempName: '',
      showDialogSaveIndTemp: false,
      activeServiceIndex: 0,
      showLegacyServiceTree: false,
      serviceSearchTimer: null,
      indTempSearchTimer: null
    }
  },
  async created () {
    if (this.type === 4) {
      this.getListSupplier()
    }
    this.setDefaultName()
    await this.getIndicationClasses()
    await this.prepare()
  },
  watch: {
    'selected.length' (length, old) {
      if (length && old) {
        this.handleSetCheckedKeys()
      }
      if (length > old) {
        this.scrollSelectedIndicationsToBottom()
      }
    },
    selected: {
      handler () {
        this.handleSetCheckedKeys()
      },
      deep: true
    },
    patientVisit (data) {
      if (data) this.patientVisit = data
      console.log(data)
    },
    selectedIndTemp: {
      handler (val) {
        if (!val || !val.id) {
          this.selected = []
          this.handleSetCheckedKeys()
          return
        }
        this.handleSelectIndTemp(val)
      },
      deep: true
    }
  },
  computed: {
    handledIndicationCategories () {
      if (!this.indicationServices) return []
      let result = this.indicationServices.map(ig => {
        // ig.level = 1
        // // ig.label = ig.name
        // let foundHasResult = this.selected.find((I) => {
        //   return I.id === ig?.id && .indication_order_id
        // })
        // ig.disabled = !!foundHasResult
        return ig
      })
      return result
    },
    modifiable () {
      if (this.prop_indication_order) {
        return (this.editing = true)
      }
      return !this.prop_indication_order || !!this.editing
    },
    noMore () {
      if (this.selectedIndicationType === null) {
        return this.allIndicationTypes.every(type => {
          const page = this.indicationPagingByType[type]
          return page && page.current_page >= page.total_page
        })
      }
      return (
        !this.indicationCategoriesPaging?.total_page ||
        this.indicationCategoriesPaging.current_page >=
          this.indicationCategoriesPaging.total_page
      )
    },
    disabledScroll () {
      return (
        this.indication_class_loading ||
        this.indication_categories_loading ||
        this.noMore
      )
    }
    // selectedEcomService () {
    //   return this.selected
    //     ?.filter((item) => item.isEcom)
    //     ?.map((item) => {
    //       delete item?.indicationAmount
    //       return item
    //     })
    // }
  },
  async mounted () {},
  methods: {
    focusServiceSearch () {
      this.$nextTick(() => {
        if (this.$refs.serviceSearchInput && this.$refs.serviceSearchInput.focus) {
          this.$refs.serviceSearchInput.focus()
        }
      })
    },
    async getListSupplier () {
      const params = {
        limit: 1000,
        page: 1
      }
      this.indication_class_loading = true
      const res = await this.$rf
        .getRequest('DoctorRequest')
        .getListSupplier(params, this.$clinicId)
      this.demo = res.data.data.map(x => ({
        id: x.supplier_id,
        name: x.supplier_name,
        org_id: x.provider_id
      }))
      this.indication_class_loading = false
    },
    ...mapActions('appointmentStore', ['updatePatientVisitByIdRequest']),
    async prepare () {
      // this.indicationServices = this.prop_indication_order?.indication || []
      const [loadedIOrderDetail, loadedICategories] = await Promise.all([
        this.getIndicationOderDetail(this.prop_indication_order?.id || null),
        this.getIndicationsCategories(),
        this.getIndTemps()
      ])
      if (loadedIOrderDetail && loadedICategories) {
        this.handlerIndicationsOrder()
      }
      this.activeServiceIndex = 0
      this.focusServiceSearch()
    },
    onSearch (search) {
      this.search = search
      this.getIndicationsCategories().then(() => {
        this.activeServiceIndex = 0
      })
    },
    handleSearchService () {
      if (this.serviceSearchTimer) clearTimeout(this.serviceSearchTimer)
      this.serviceSearchTimer = setTimeout(() => {
        this.onSearch(this.search)
      }, 250)
    },
    selectIndicationType (type) {
      this.selectedIndicationType = type
      this.indicationClassParentId = null
      this.getIndicationsCategories()
    },
    async getIndicationClasses () {
      const params = {
        level: 1,
        all: true
      }
      this.indication_class_loading = true
      const res = await this.$rf
        .getRequest('DoctorRequest')
        .getIndicationClasses(params)
      this.indicationClasses = res?.data
      this.indication_class_loading = false
    },
    handleNexPageCategories () {
      if (this.noMore) return
      this.getIndicationsCategories(true)
    },
    async getIndicationsCategories (isNext = false) {
      if (!this.$globalClinic?.id) return
      if (!isNext) {
        this.indicationServices = []
        this.indicationPagingByType = {}
      }
      this.indication_categories_loading = true
      try {
        const groups = this.selectedIndicationType === null
          ? this.allIndicationTypes
          : [this.selectedIndicationType]
        const pageLoads = groups.map(groupId => {
          const oldPage = this.indicationPagingByType[groupId]
          if (isNext && oldPage && oldPage.current_page >= oldPage.total_page) return Promise.resolve(null)
          const pageNum = isNext && oldPage ? oldPage.current_page + 1 : 1
          return this.fetchIndicationCategoryPage(groupId, pageNum)
        })
        const loadedPages = (await Promise.all(pageLoads)).filter(Boolean)
        const newItems = loadedPages.reduce((items, result) => items.concat(result.items), [])
        this.indicationServices = isNext ? [...this.indicationServices, ...newItems] : newItems
        loadedPages.forEach(result => {
          this.$set(this.indicationPagingByType, result.groupId, result.page)
        })
        if (this.selectedIndicationType !== null) {
          this.indicationCategoriesPaging = this.indicationPagingByType[this.selectedIndicationType] || {}
        }
        return true
      } catch (error) {
        console.log(error)
        return false
      } finally {
        this.indication_categories_loading = false
      }
    },
    async fetchIndicationCategoryPage (groupId, pageNum) {
      const response = await this.$rf.getRequest('DoctorRequest').getLocalService({
        keyword: this.search,
        page_num: pageNum,
        group_id: groupId,
        page_size: 20,
        ws_id: this.$globalClinic?.id
      })
      const body = response?.data?.code ? response.data : (response?.data || response)
      const payload = body?.data || {}
      const results = Array.isArray(payload) ? payload : (payload?.data || payload?.items || [])
      const page = payload?.page || body?.page || {}
      return {
        groupId,
        page: { ...page, current_page: page?.page_num || pageNum, total_page: page?.total_page || pageNum },
        items: results.map(item => ({
          ...item,
          indicationOrderType: groupId,
          local_service_id: item?.service_locals?.id
        }))
      }
    },
    selectIndicationClasses (classId) {
      if (classId) {
        this.indicationClassParentId = classId
      } else {
        this.indicationClassParentId = null
      }
      this.getIndicationsCategories()
    },
    async getIndicationOderDetail (id) {
      if (!id) {
        this.indication_order = null
        return
      }
      this.loading = true
      const loaded = await this.$rf
        .getRequest('DoctorRequest')
        .getIndicationDetailV2(id)
        .then(r => {
          this.indication_order = r.data
          this.indicationResponse = r.data
          return true
        })
        .finally(() => {
          this.loading = false
          return false
        })
      return loaded
    },
    setNameTargetIndication (item, t) {
      this.$set(item, 'org_id', t.org_id)
      this.$set(item, 'target_name', t.name)
      this.$set(item, 'target_id', t.id)
    },
    async ApptStatus (value) {
      const params = {
        status: value
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .ApptStatus(this.appointment.id, params)
      this.getAppts()
    },
    baseDataUpdate (record) {
      return {
        appt_id: record?.appt_id || null,
        clinic_id: record?.clinic_id || null,
        doctor_id: record?.doctor?.id || null,
        cr_id: record?.cr_id || null,
        person_id: record?.person_id || null,
        start_time: record?.start_time
          ? window.moment(record.start_time).utc().format('YYYY-MM-DD HH:mm:ss')
          : null,
        end_time: record?.end_time
          ? window.moment(record.end_time).utc().format('YYYY-MM-DD HH:mm:ss')
          : null,
        checkin_time: record?.checkin_time
          ? window.moment(record.checkin_time).format('YYYY-MM-DD HH:mm:ss')
          : null,
        cancel_reason: ''
      }
    },
    async baseHandle ({ record, status }) {
      const self = this
      if (!record || !status) {
        self.$message({
          type: 'error',
          message: self.$t(`Không tìm thấy thông tin bệnh nhân`)
        })
        return
      }
      const data = self.baseDataUpdate(record)
      await this.updatePatientVisitByIdRequest({
        id: record.id,
        data: {
          ...data,
          status: status
        },
        isDetail: false
      })
    },
    async updateIndicationOrder () {
      if (!this.prop_indication_order) return

      const r = await this.$confirm(
        'Bạn có chắc chắn muốn cập nhật Chỉ định không?',
        'Xác nhận tạo Chỉ định',
        {
          dangerouslyUseHTMLString: true,
          cancelButtonText: this.$t('lbl_cancel'),
          confirmButtonText: this.$t('lbl_confirm')
        }
      ).catch(() => {})

      if (!r) return

      // const cateIds = this.selected.map((item) => {
      //   item.remove = false
      //   delete item.target_name
      //   return item
      // })
      // const reomovedIds = this.deleted.map((item) => {
      //   item.remove = true
      //   return item
      // })
      // const indications = [...cateIds, ...reomovedIds]
      // const indications = [...cateIds]

      const params = {
        cate: this.type,
        patient_visit_id: this.patient_visit_id,
        name: this.form.name,
        indications: this.getSelectedPayload()
      }
      this.loading = true
      await this.$rf
        .getRequest('DoctorRequest')
        .putIndicationOder(this.prop_indication_order.id, params)
        .then(res => {
          this.$toast.open({
            message: 'Cập nhật thành công',
            type: 'success'
          })

          if (this.prop_indication_order) {
            this.$emit('refresh', {
              reCall: true
            })
          } else {
            this.$emit('refresh', false)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onSubmit (hasChecked, otpData) {
      if (!this.form.name) {
        this.$message({
          type: 'error',
          message: this.$t(`Vui lòng nhập tên phiếu chỉ định.`)
        })
        return
      }
      if (!this.selected || !this.selected.length) {
        this.$message({
          type: 'error',
          message: this.$t(`Vui lòng chọn chỉ định.`)
        })
        return
      }

      const hasEcomIndication = this.selected?.some(
        item => item?.type_service === 1
      )

      if (hasEcomIndication && !hasChecked) {
        // this.stepConfirm = 1
        this.$refs.ModalConfirmConcent.handleOpen(this.patientVisit)
        return
      }

      if (this.prop_indication_order) {
        this.updateIndicationOrder()
        return
      }
      // if (this.type === 4 && this.selected.find((x) => x.target_name === '')) {
      //   this.$message({
      //     type: 'error',
      //     message: this.$t(`Vui lòng điền thông tin nơi thực hiện`)
      //   })
      //   return
      // }
      if (!hasChecked) {
        const r = await this.$confirm(
          'Bạn có chắc chắn muốn tạo chỉ định không?',
          'Xác nhận tạo Chỉ định',
          {
            dangerouslyUseHTMLString: true,
            cancelButtonText: this.$t('lbl_cancel'),
            confirmButtonText: this.$t('lbl_confirm')
          }
        ).catch(() => {})

        if (!r) return
      }

      try {
        this.loading = true
        const groups = new Map()
        const selectedItems = this.getSelectedPayload()
        const ungrouped = selectedItems.find(item => !item.group_id)
        if (ungrouped) {
          this.$message({ type: 'error', message: `Không xác định được nhóm chỉ định của dịch vụ "${ungrouped.name || ''}".` })
          return
        }
        selectedItems.forEach(item => {
          const group = item.group_id
          if (!groups.has(group)) groups.set(group, [])
          groups.get(group).push(item)
        })
        for (const [group, items] of groups.entries()) {
          let res
          if (this.hasEHCConnect) {
            const params = {
              cate: Number(group),
              clinic_id: this.$globalClinic.id,
              date: moment().format('yyyy-MM-DD HH:mm'),
              name: this.form.name,
              diagnostic_code: this.patientVisit?.icd_code || '',
              diagnostic_name: this.patientVisit?.icd_name || '',
              patient_visit_id: this.patientVisit?.id,
              person_id: this.patientVisit?.person.id,
              treatment_items: items.map(item => ({ quantity: item?.indicationAmount || 1, service_code: item?.services_code || '' }))
            }
            res = await this.$rf.getRequest('DoctorRequest').createIndicationEHCKTV(params)
          } else {
            const params = {
              cate_id: Number(group),
              patient_visit_id: this.patient_visit_id,
              name: this.form.name,
              indications: items.map(item => ({ ...item, qty: item?.indicationAmount || 1 })),
              user_id: otpData?.user_id,
              otp: otpData?.otp
            }
            res = await this.$rf.getRequest('DoctorRequest').createIndicationV2(params)
          }
          if (!res.status) throw new Error('Failed to create indication order')
        }

        // this.indicationServices = res.data?.indication || []
        // this.indicationResponse = res.data

        // if (this.type === 4) {
        //   const paramIndication = {
        //     doctor_id: this.$user.doctor.id,
        //     indications: res.data.indications.map((x) => ({
        //       indication_category_id: x.indication_category_id,
        //       indication_id: x.id,
        //       supplier_id: this.selected.find(
        //         (i) => i.indication_category_id === x.indication_category_id
        //       ).target_id,
        //       org_id: this.selected.find(
        //         (i) => i.indication_category_id === x.indication_category_id
        //       ).org_id
        //     })),
        //     order_contact: {
        //       address1: this.patientVisit.person.address,
        //       address2: this.patientVisit.person.address,
        //       name: this.patientVisit.person.name,
        //       phone: this.patientVisit.person.phone
        //     },
        //     order_date: Date.now(),
        //     workspace_id: this.$globalClinic.id
        //   }
        //   const resp = await this.$rf
        //     .getRequest('DoctorRequest')
        //     .postIndicationProductOder(paramIndication)
        //   if (!resp.data) return
        // }
        await this.baseHandle({
          record: this.patientVisit,
          status: EXAMINATION_STATUS.CODE.WAITING_READ_RESULT
        })
        if (hasChecked) {
          this.$refs.ModalEnterOTP.handleSuccess()
        }
        this.isDisabledCreate = true
        this.$message({
          message: 'Tạo phiếu chỉ định thành công',
          type: 'success'
        })
      } catch (error) {
        this.loading = false
        this.$message({
          message: 'Tạo phiếu chỉ định thất bại',
          type: 'error'
        })
      } finally {
        this.loading = false
        // this.prepare()
        if (this.prop_indication_order) {
          this.$emit('refresh', {
            reCall: true
          })
        } else {
          this.$emit('refresh', true)
        }
        // this.handlerCancel()
      }
    },
    handlerCancel () {
      this.prepare()
      if (this.prop_indication_order) {
        this.$emit('refresh', {
          reCall: true
        })
      } else {
        this.$emit('refresh')
      }
    },
    setDefaultName () {
      this.form.name =
        this.$t('schedule_page.lbl_indication_sheet') +
        moment().format('HH:mm:ss DD/MM/YYYY')
    },
    getDataDemo (id) {
      return id ? this.demo[id - 1].name : ''
    },
    handlerIndicationsOrder () {
      if (this.selected.length) return
      this.selected = this.selected.filter(s => !s.id)
      if (this.indication_order?.name) {
        this.form.name = this.indication_order?.name
      } else {
        this.setDefaultName()
      }
      if (this.indicationServices?.length) {
        let _tempSelected = []
        this.indicationServices.map(item => {
          _tempSelected.push({
            ...item,
            indication_category_id: item.service_catalog?.services_category_id,
            name: item.local_name,
            services_code: item.service_catalog?.services_code,
            status: item.status,
            type_service: 2, // Service local
            type_service_id: item.id
            // target_id: item.target_id,
            // target_name: this.getDataDemo(item.target_id),
            // due_date: item.due_date,
          })
        })

        const arr = _tempSelected
        this.selected = arr.map(item => ({
          ...item,
          indicationAmount: item?.indicationAmount || 1
        }))

        // this.selected = _tempSelected
        this.handleSetCheckedKeys()
      }
    },
    goToPrint () {
      this.$router.push({
        name: 'CaseIndicationsPrinter',
        params: { id: this.prop_indication_order.id }
      })
    },
    getCategoryLabel (string) {
      return string?.replaceAll('-', ' &nbsp; ')
    },
    normalizeServiceId (data) {
      return (
        data?.services_code ||
        data?.service_catalog?.services_code ||
        data?.service_catalog_id ||
        data?.service_catalog?.id ||
        data?.type_service_id ||
        data?.id
      )
    },
    isServiceSelected (data) {
      const id = this.normalizeServiceId(data)
      return this.selected?.some(item => this.normalizeServiceId(item) === id)
    },
    findLocalServiceByTemplateItem (item) {
      const serviceCatalog = item?.service_catalog || item
      const servicesCode = item?.services_code || serviceCatalog?.services_code
      const serviceCatalogId = item?.service_catalog_id || serviceCatalog?.id
      return this.indicationServices?.find(service => {
        return (
          (servicesCode && service?.service_catalog?.services_code === servicesCode) ||
          (serviceCatalogId && service?.service_catalog?.id === serviceCatalogId)
        )
      })
    },
    mapServiceToSelected (data, amount = 1) {
      return {
        ...data,
        id: data.id,
        indication_category_id: data.service_catalog?.services_category_id || data.indication_category_id,
        name: data.name || data.local_name,
        local_name: data.local_name || data.name,
        services_code: data.services_code || data.service_catalog?.services_code,
        service_catalog_id: data.service_catalog_id || data.service_catalog?.id,
        status: data.status,
        type_service: data.type_service || 2,
        type_service_id: data.type_service_id || data.id,
        group_id: data.indicationOrderType || data.indication_type || data.group_id || data.indication_group_id || data.cate_id || data.service_catalog?.group_id || data.service_catalog?.indication_type || this.selectedIndicationType || null,
        indicationAmount: amount || data?.indicationAmount || 1
      }
    },
    moveActiveService (step) {
      const total = this.handledIndicationCategories.length
      if (!total) return
      const next = this.activeServiceIndex + step
      if (next < 0) {
        this.activeServiceIndex = total - 1
      } else if (next >= total) {
        this.activeServiceIndex = 0
      } else {
        this.activeServiceIndex = next
      }
      this.scrollActiveServiceIntoView()
    },
    scrollActiveServiceIntoView () {
      this.$nextTick(() => {
        const list = this.$refs.quickServiceList
        if (!list || !list.children || !list.children[this.activeServiceIndex]) return
        list.children[this.activeServiceIndex].scrollIntoView({
          block: 'nearest'
        })
      })
    },
    toggleActiveService () {
      const item = this.handledIndicationCategories[this.activeServiceIndex]
      if (!item) return
      this.toggleServiceSelection(item)
    },
    toggleServiceSelection (item) {
      this.handleCheckChange(item, !this.isServiceSelected(item), true)
    },
    getSelectedPayload () {
      return this.selected.map(item => this.mapServiceToSelected(item, item?.indicationAmount || item?.qty || 1))
    },
    handleCheckChange (data, checked, handle) {
      const _tempSelected = this.selected || []
      const dataKey = this.normalizeServiceId(data)

      if (!checked) {
        const foundIndex = _tempSelected?.findIndex(item => this.normalizeServiceId(item) === dataKey)

        if (foundIndex === -1) return
        this.deleted.push(_tempSelected[foundIndex])
        const arr = _tempSelected?.filter(item => this.normalizeServiceId(item) !== dataKey)
        this.selected = arr.map(item => ({
          ...item,
          indicationAmount: item?.indicationAmount || 1
        }))

        // this.selected =
        if (handle) {
          this.handleSetCheckedKeys()
        }
        return
      }

      const foundData = _tempSelected?.find(item => this.normalizeServiceId(item) === dataKey)

      if (foundData || typeof foundData !== 'undefined') return
      this.selected = [
        ..._tempSelected,
        this.mapServiceToSelected(data, 1)
      ]
      this.scrollSelectedIndicationsToBottom()
      if (handle) {
        this.handleSetCheckedKeys()
      }
    },
    scrollSelectedIndicationsToBottom () {
      this.$nextTick(() => {
        const list = this.$refs.selectedIndicationList
        if (list) list.scrollTop = list.scrollHeight
      })
    },
    handleSetCheckedKeys () {
      try {
        if (!this.selected.length) {
          this.$refs.tree.setCheckedKeys([])
          return
        }
        const codes = this.selected?.map(item => item?.id) || []
        this.$refs.tree.setCheckedKeys(codes)
      } catch (error) {}
    },
    handleDeleteIndication (data) {
      if (!data) return
      this.selectedEcomService = this.selectedEcomService?.filter(
        item => item?.id != data?.id
      )
      this.handleCheckChange(data, false, true)
    },
    handleAddReceipt () {
      this.$router.push({
        name: 'CreateIndicationReceipt',
        params: {
          ps_id: this.$route.params.id
        }
      })
    },
    handleRefresh (value) {
      this.ctaTrigger++
      this.handleOpenListReceipt()
      this.handleOpenModalAddReceipt('')
    },
    handleOpenListReceipt () {
      this.$refs.ModalIndicationReceipt.handleOpen()
    },
    handleOpenModalAddReceipt (show) {
      window.$('#modal-add-receipt-form').modal(show ? 'show' : 'hide')
    },
    handleCloseModalIndicationReceipt () {
      this.$emit('refresh')
    },
    getLabelIndication (data) {
      const providerName = data?.service_catalog?.service_provider?.name
        ? `(${data?.service_catalog?.service_provider?.name})`
        : ''

      return `${data.local_name} ${providerName}`
    },
    handleOpenModalSelectServicePublic () {
      this.$refs.ModalSelectServicePublic.handleOpen()
    },
    handleSelectServiceEcom (data) {
      this.selectedEcomService = data
      const _tempSelected = cloneDeep(this.selected)?.filter(
        item => !item.isEcom
      )

      const mapData = data?.map(item => ({
        ...item,
        indication_category_id: item.services_category_id,
        local_name: item.name,
        services_code: item.service_catalog?.services_code,
        status: item.status,
        type_service: 1, // Service catalog
        type_service_id: item.id,
        isEcom: true
      }))
      const arr = [..._tempSelected, ...mapData]
      this.selected = arr.map(item => ({
        ...item,
        indicationAmount: item?.indicationAmount || 1
      }))
    },
    handleOpenModalEnterOTP (user_id) {
      this.$refs.ModalEnterOTP.handleOpen(this.patientVisit, user_id)
    },
    getIndicationName (data) {
      return data?.local_name
    },
    async getIndTemps (searchValue) {
      if (!this.$globalClinic?.id) return
      const params = {
        clinic_id: this.$globalClinic?.id,
        type: this.type || null,
        keyword: searchValue || '',
        page_size: 1000,
        page_num: 1
      }
      try {
        const res = await this.$rf.getRequest('DoctorRequest').getIndTemps(params)
        this.indTemps = res?.data?.data || []
      } catch (error) {
        console.error(error)
      }
    },
    handleSearchIndTemp () {
      if (this.indTempSearchTimer) clearTimeout(this.indTempSearchTimer)
      this.indTempSearchTimer = setTimeout(() => {
        this.getIndTemps(this.indTempSearch)
      }, 250)
    },
    selectIndicationTemplate (item) {
      if (this.selectedIndTemp && this.selectedIndTemp.id === item.id) {
        this.selectedIndTemp = null
        this.selected = []
        this.handleSetCheckedKeys()
        return
      }
      this.selectedIndTemp = item
    },
    getTemplateServiceCount (item) {
      return item?.indication_forms?.length || 0
    },
    handleSelectIndTemp (selected) {
      if (!selected || !selected.id) return
      if (Array.isArray(selected.indication_forms) && selected.indication_forms.length) {
        const items = selected.indication_forms.map(item => {
          const localService = this.findLocalServiceByTemplateItem(item)
          const source = localService || {
            ...item.service_catalog,
            id: item.service_catalog?.id,
            service_catalog_id: item.service_catalog?.id,
            local_name: item?.local_name || item?.service_catalog?.name,
            services_code: item?.services_code || item.service_catalog?.services_code,
            type_service: 2,
            type_service_id: item.service_catalog?.id,
            service_catalog: item.service_catalog
          }
          return this.mapServiceToSelected(source, item?.indicationAmount || item?.qty || 1)
        })
        this.selected = cloneDeep(items)
        this.handleSetCheckedKeys()
      }
    },
    async deleteTemplate (item) {
      this.$confirm(`Bạn chắc chắn muốn xoá mẫu phiếu <strong>${item.name}</strong> không?`, 'Xác nhận xoá mẫu phiếu', {
        confirmButtonText: 'Xác nhận',
        dangerouslyUseHTMLString: true
      }).then(async _ => {
        this.loading = true
        await this.$rf
          .getRequest('DoctorRequest')
          .deleteIndTemp(item.id)
          .then(async r => {
            if (r?.code === 200) {
              await this.getIndTemps()
              this.selected = []
              this.selectedIndTemp = null
              this.$message({
                message: 'Xoá template thành công',
                type: 'success'
              })
            } else {
            }
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    handleShowDialogSaveIndTemp () {
      if (!this.selected || !this.selected.length) {
        this.$message({ type: 'error', message: this.$t(`Vui lòng chọn chỉ định để lưu mẫu.`) })
        return
      }
      this.showDialogSaveIndTemp = true
    },
    handleCancelSaveIndTemp () {
      this.showDialogSaveIndTemp = false
      this.indTempName = ''
    },
    handleSaveIndTemp () {
      if (!this.indTempName) {
        this.$message({ type: 'error', message: this.$t(`Vui lòng nhập tên mẫu phiếu chỉ định.`) })
        return
      }
      const payload = {
        name: this.indTempName,
        clinic_id: this.$globalClinic?.id,
        type: this.type || null,
        indication_forms: this.selected.map(item => ({
          services_code: item.services_code
        }))
      }
      this.loading = true
      this.$rf
        .getRequest('DoctorRequest')
        .createIndTemp(payload)
        .then(async r => {
          if (r?.status === 200) {
            await this.getIndTemps()
            this.$message({
              message: 'Lưu mẫu phiếu chỉ định thành công',
              type: 'success'
            })
            this.handleCancelSaveIndTemp()
            this.selectedIndTemp = r?.data || null
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__body {
    padding: 16px 10px;
  }
  .el-tree-node__content {
    height: 48px;
  }
  .input-deal-date .el-input__inner {
    border: 0;
    background-color: white !important;
    font-size: 14px;
    font-weight: normal !important;
    color: #667085 !important;
  }
  .input-deal-date .el-input__inner::-webkit-input-placeholder {
    color: #667085; /*Change the placeholder color*/
    opacity: 1; /*Change the opacity between 0 and 1*/
  }
}
.h-40px {
  height: 40px;
}
.disable-click {
  pointer-events: none;
  opacity: 0.7;
}
.select-items {
  height: calc(100vh - 440px);
  overflow-x: hidden;
  overflow-y: auto;
}
.select-class {
  overflow-x: auto;
  width: 100%;
}
.class-item {
  white-space: nowrap;
  flex-grow: 1;
}
.delete-indication-wraper {
  width: 40px;
}
.delete-indication {
  display: none;
  cursor: pointer;
}
.btn-add {
  &:hover {
    background: #ecf5ff;
  }
}

.indication-item-hover:hover .delete-indication {
  display: block;
}
.selected-indication {
  padding-right: 8px;
  max-height: calc(100vh - 350px);
  overflow-y: auto;
}
.selected-indication.ind-temp-selected {
  max-height: calc(100vh - 475px) !important;
}
.selected-indication-item {
  margin-bottom: 6px;
  border-radius: 6px;
  border: 0.5px solid #e6e6e6;
  padding: 4px 6px;
}
.selected-indication-item p {
  font-size: 14px;
  line-height: 18px;
}
.selected-indication-item:hover {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
}
.box-shadow {
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
}

.quick-service-list {
  height: calc(100vh - 260px);
  min-height: 360px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  outline: none;
}

.quick-service-item {
  min-height: 48px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.quick-service-item:last-child {
  border-bottom: 0;
}

.quick-service-item-active {
  background: #dbeafe;
}

.quick-service-item-selected {
  border-left: 5px solid #20409b;
  background: #c7d2fe;
  color: #111827;
  box-shadow: inset 0 0 0 1px #20409b;
}

.ind-temp-list {
  max-height: 174px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

//.ind-temp-list-empty {
//  min-height: 48px;
//}

.ind-temp-item {
  min-height: 58px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
}

.ind-temp-item:last-child {
  border-bottom: 0;
}

.ind-temp-item:hover,
.ind-temp-item-active {
  background: #dbeafe;
}

.ind-temp-item-active {
  border-left: 5px solid #20409b;
  background: #c7d2fe;
  color: #111827;
  box-shadow: inset 0 0 0 1px #20409b;
}

.custom-tree-node {
  white-space: pre-wrap;
}

.cs-input {
  max-width: 150px;
  text-align: center;
}
</style>
